import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { documentsSectionFromResponse } from '../../documents/recordDocumentsSection';
import { registryHref } from '../../registryHref';
export function govOrgRail(d, docs, intel, documentsState) {
    const parent = d.ancestors.at(-1);
    const last = d.relationship?.lastContact;
    const date = last?.at?.toDate();
    return [
        {
            id: 'facts',
            title: 'Facts',
            rows: [
                ...d.officeCode ? [
                    {
                        id: 'office',
                        label: 'Office code',
                        value: /*#__PURE__*/ _jsx("span", {
                            "data-testid": Testids.registryGovOrg.factsOfficeCode,
                            children: d.officeCode
                        })
                    }
                ] : [],
                ...parent ? [
                    {
                        id: 'parent',
                        label: 'Parent',
                        value: /*#__PURE__*/ _jsx(SpecraLink, {
                            href: registryHref(parent) ?? undefined,
                            renderLink: renderRouterLink,
                            children: parent.name
                        })
                    }
                ] : [],
                ...d.locationText ? [
                    {
                        id: 'location',
                        label: 'Location',
                        value: d.locationText
                    }
                ] : []
            ],
            children: d.readOnlyReference ? /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: [
                    d.referenceSource ? `Source: ${d.referenceSource}. ` : '',
                    "Read-only reference data."
                ]
            }) : undefined
        },
        {
            id: 'relationship',
            title: 'Our relationship',
            rows: [
                {
                    id: 'touchpoints',
                    label: 'Touchpoints this year',
                    value: d.relationship?.visibleTouchpointsThisYear ?? 0
                },
                {
                    id: 'people',
                    label: 'People we know here',
                    value: d.relationship?.knownPeople ?? 0
                },
                ...date ? [
                    {
                        id: 'last',
                        label: 'Last contact',
                        value: `${date.getUTCDate()} ${date.toLocaleDateString('en-US', {
                            month: 'short',
                            timeZone: 'UTC'
                        })} ${date.getUTCFullYear()}${last?.context?.name ? ` · ${last.context.name}` : ''}`
                    }
                ] : []
            ]
        },
        intel,
        documentsSectionFromResponse({
            kind: 'GOVERNMENT_ORG',
            id: d.orgId
        }, docs, documentsState)
    ];
}
